import Spinner from "components/Spinner";
import WoStatusOptions from "components/WoStatusOptions";
import { setNotification } from "features/Notification/notificationSlice";
import { useState } from "react";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";
import * as XLSX from "xlsx";

export default function ExportWorkOrder({ locationsList }) {
  const dispatch = useDispatch();

  /*   All States
   ********************************************* */
  // const [selectedLocation, setSelectedLocation] = useState(null);
  const [exportOptions, setExportOptions] = useState({
    WOStatus: "all",
    selectedLocation: null,
  });
  const [loading, setLoading] = useState(null);

  /*   All Functions
   ********************************************* */
  const getWoExportData = async () => {
    try {
      // let locationId = searchParams.get("location");
      setLoading(true);
      const { data } = await API.post(
        "/work-order/export",
        {
          locationId: exportOptions.selectedLocation,
          WOStatus: exportOptions.WOStatus,
        },
        {
          headers: authHeader(),
        }
      );
      if (data?.success) {
        return data.result;
      } else {
        dispatch(
          setNotification({
            message: "Error Fetching export data",
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const addLocationIds = (data) => {
    let locations = locationsList?.reduce((acc, curr) => {
      acc[curr?.id] = curr.locationName;
      return acc;
    }, {});

    // No Customer ID column (user, 2026-10-27): it is the internal id, not
    // the C-number anyone would recognise.
    let updatedData = data?.map(({ customerId, ...item }) => {
      item["location"] = locations[item?.locationId];
      return item;
    });
    return updatedData;
  };

  const downloadExcel = async () => {
    try {
      setLoading(true);
      const data = await getWoExportData();
      const updatedData = addLocationIds(data);

      const worksheet = XLSX.utils.json_to_sheet(updatedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, `${exportOptions.WOStatus}.xlsx`);
      setLoading(false);
    } catch (err) {
      console.log(err.message);
      setLoading(false);
    }
  };

  /*   All UseEffects
   ********************************************* */
  return (
    <div className="mt-3">
      {loading && <Spinner />}
      {/* Customer Option Card */}
      <div className="card">
        <div className="card-body">
          <div className="">
            <h4 className="">IMPORT DATA FILE</h4>
          </div>
          <hr className="mt-0" />
          <div className="d-flex justify-content-start align-items-center gap-3 mb-3">
            <div>
              <label>
                Status:
                <select
                  className="form-select"
                  value={exportOptions.WOStatus}
                  onChange={(e) =>
                    setExportOptions({
                      ...exportOptions,
                      WOStatus: e.target.value,
                    })
                  }
                >
                  <option value="all">All</option>
                  {/* Settings -> WO Statuses (2026-10-29) */}
                  <WoStatusOptions />
                </select>
              </label>
            </div>
            <div>
              <label>
                Location:
                <select
                  className="form-select"
                  value={exportOptions.selectedLocation || ""}
                  onChange={(e) =>
                    setExportOptions({
                      ...exportOptions,
                      selectedLocation: e.target.value || null,
                    })
                  }
                >
                  <option value="">All Brands</option>
                  {locationsList?.map((location) => (
                    <option key={location.id} value={location.id}>
                      {location.locationName}
                    </option>
                  ))}
                </select>
              </label>
            </div>
          </div>
          <button
            className="btn btn-primary"
            onClick={downloadExcel}
            disabled={loading}
          >
            Download Excel
          </button>
        </div>
      </div>
    </div>
  );
}
